import Root from './containers/Root';
import app from '../../containers/App/App';
import './forgot.password.cshtml';

app(Root, 'ForgotPasswordComponent');
